import React from 'react';
export default ({ className }: { className?: string }) => (
	<svg
		width="24px"
		height="24px"
		viewBox="0 0 24 24"
		fill="none"
		stroke="currentColor"
		strokeWidth="2"
		strokeLinecap="round"
		strokeLinejoin="round"
		className={className}
	>
		<line x1="5" y1="12" x2="19" y2="12"></line>
	</svg>
);
